import { render, staticRenderFns } from "./BankListApprove.vue?vue&type=template&id=b5a316ce"
import script from "./BankListApprove.vue?vue&type=script&lang=js"
export * from "./BankListApprove.vue?vue&type=script&lang=js"
import style0 from "./BankListApprove.vue?vue&type=style&index=0&id=b5a316ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports